<!--type:1单选，0多选-->
<template>
    <div class=""><i v-if=" Data.attr.c_priority==='S'" class="fa fa-asterisk text-danger font10 ml-1"
                     aria-hidden="true"></i>{{ Data.attr.title }}：
        <div class="card-body">
            <div v-if="Data.data.length===0||Data.data===undefined">暂无数据</div>
            <el-checkbox-group v-model="value" @change='get_choice' :max="get_max" :min="get_min"
                               :disabled="Data.attr.disabled===undefined?false:Data.attr.disabled">
                <el-checkbox v-for="(val,index) in Data.data" :key="index" :label="val.id"
                             :disabled="val.disabled===undefined?false:val.disabled">{{ val.name }}
                </el-checkbox>
            </el-checkbox-group>
            <div class="mt-2">

                <el-button slot="trigger" size="small" type="primary"
                           v-if="Data.attr.show_clear===undefined?true:Data.attr.show_clear"
                           @click="clear_choice">重置
                </el-button>
                <el-button slot="trigger" size="small" type="primary"
                           v-if="Data.attr.show_all===undefined?true:Data.attr.show_all" :disabled="get_max===1"
                           @click="get_all">全选
                </el-button>
            </div>

        </div>
        <hr>
    </div>

</template>
<script>
export default {
    name: "object_select",
    props: [
        'Data'
    ],
    data() {
        return {
            value: this.Data.attr.list === undefined ? [] : this.Data.attr.list,
        }
    },
    mounted() {
      console.log(this.Data,'223')
    },
    computed: {
        get_max: function () {
            if (this.Data.attr.type === 0) {
                return 999
            } else return 1
        },
        get_min: function () {
            if (this.Data.attr.c_priority === 'S') {
                return 1
            } else return 0
        },
    },
    methods: {

        get_choice() {
            this.$get_objects(this.Data, this.value)
            if (this.Data.attr.func !== undefined) {
                this.$emit(this.Data.attr.func, this.value)
            }
        },
        get_all: function () {
            this.value = []
            for (const i in this.Data.data) {
                this.value.push(this.Data.data[i].id)
            }
            this.$get_objects(this.Data, this.value)
            if (this.Data.attr.func !== undefined) {
                this.$emit(this.Data.attr.func, this.value)
            }
        },
        clear_choice() {
            this.value = []
            this.$get_objects(this.Data, this.value)
            if (this.Data.attr.func !== undefined) {
                this.$emit(this.Data.attr.func, this.value)
            }
        },
    }
}
</script>

<style scoped>

</style>
